import React from "react";
import NavigationHeader from "../../components/ui/NavigationHeader";
import IPDVModule from "../comercial-dashboard/components/IPDVModule";

// Área independente: nenhum dado comercial geral é buscado por esta página.
export default function PromotorDeVendasPage() {
  return (
    <div className="min-h-screen bg-[#f7ecd9] text-[#3b1d0f]">
      <NavigationHeader />
      <main className="mx-auto max-w-[1700px] px-4 pb-10 pt-7 md:px-7">
        <h1 className="mb-5 text-2xl font-black">Promotor de Vendas</h1>
        <IPDVModule />
      </main>
    </div>
  );
}
